import { invokeApi } from '@/common/invokeApi/invokeApi';

export type FetchPatientWorkQueueColumnSettingsParams = {
  teamId?: string;
};

export const fetchPatientWorkQueueColumnSettings = async ({
  teamId,
}: FetchPatientWorkQueueColumnSettingsParams) =>
  await invokeApi({
    path: teamId
      ? `/patient-queue/column-settings/teams/${teamId}`
      : '/patient-queue/column-settings',
  });
